export const appGroupIdCampaignCampaignIdMessagesMessageVariationId =
  "/:app_group_id/campaign/:campaign_id/message/:message_variation_id";
